module.exports = __webpack_public_path__ + "img/a-mission.80a498bd.png";